import ApplicationSuccessModal from './ApplicationSuccessModal';
import Modal from './Modal';

import { modalStore } from '../models/stores';

const MODAL_COMPONENTS = {
  APPLY_SUCCESS: ApplicationSuccessModal,
};

function Modals() {
  return <Modal components={MODAL_COMPONENTS} store={modalStore} />;
}

export default Modals;
